import { config } from './config'

//----------------------DO NOT MODIFY-------------------------------

//Endpoint Configuration

export const configuration =
  process.env.REACT_APP_STAGE === 'prod'
    ? config.prod
    : process.env.REACT_APP_STAGE === 'test'
    ? config.test
    : config.dev

export const API_SERVER = configuration.API_SERVER
export const KVT_IDENTITY_SERVER = configuration.KVT_IDENTITY_SERVER
export const IDENTIFICATION_SERVER = configuration.IDENTIFICATION_SERVER
export const RESONIA_API_SERVER = configuration.RESONIA_API_SERVER
export const BUILD_DATE_ENDPOINT = configuration.BUILD_DATE_ENDPOINT
export const PAYMENTS_API_SERVER = configuration.PAYMENTS_API_SERVER
export const PAYMENTS_API_PATH_USERS = configuration.PAYMENTS_API_PATH_USERS
export const PAYMENTS_API_PATH_MAIN_ACCOUNT =
  configuration.PAYMENTS_API_PATH_MAIN_ACCOUNT
export const PAYMENTS_API_PATH_SERVICE_ACCOUNT =
  configuration.PAYMENTS_API_PATH_SERVICE_ACCOUNT
export const PAYMENTS_API_PATH_ULOSOTTO =
  configuration.PAYMENTS_API_PATH_ULOSOTTO

//----------------------DO NOT MODIFY-------------------------------

export const LOGIN_FORM_SUBMIT = 'LOGIN_FORM_SUBMIT'
export const LOGIN_FORM_SUBMIT_SUCCESS = 'LOGIN_FORM_SUBMIT_SUCCESS'
export const LOGIN_FORM_SUBMIT_FAILED = 'LOGIN_FORM_SUBMIT_FAILED'
export const CLOSE_LOGIN_SNACKBAR = 'CLOSE_LOGIN_SNACKBAR'
export const CLIENT_SET = 'CLIENT_SET'
export const CLIENT_UNSET = 'CLIENT_UNSET'
export const LOGOUT = 'LOGOUT'
export const GET_LANG_FROM_SITE = 'GET_LANG_FROM_SITE'
export const RESET_PASSWORD_FORM_SUBMIT = 'RESET_PASSWORD_FORM_SUBMIT'
export const RESET_PASSWORD_SUBMIT_SUCCESS = 'RESET_PASSWORD_SUBMIT_SUCCESS'
export const RESET_PASSWORD_SUBMIT_FAILED = 'RESET_PASSWORD_SUBMIT_FAILED'
export const HIDE_RESET_PASSWORD_SNACKBAR = 'HIDE_RESET_PASSWORD_SNACKBAR'

export const REGISTER_FORM_SUBMIT = 'REGISTER_FORM_SUBMIT'
export const REGISTER_FORM_SUBMIT_SUCCESS = 'REGISTER_FORM_SUBMIT_SUCCESS'
export const REGISTER_FORM_SUBMIT_FAILED = 'REGISTER_FORM_SUBMIT_FAILED'
export const REGISTER_FORM_SUBMIT_USER_EXIST_ERROR =
  'REGISTER_FORM_SUBMIT_USER_EXIST_ERROR'
export const CLOSE_REGISTER_SNACKBAR = 'CLOSE_REGISTER_SNACKBAR'
export const LOAD_REGISTER_FROM_SITE = 'LOAD_REGISTER_FROM_SITE'

export const CHECK_AUTH_INFO = '@@dashboard/CHECK_AUTH_INFO'
export const CHECK_AUTH_INFO_SUCCESS = '@@dashboard/CHECK_AUTH_INFO_SUCCESS'
export const CHECK_AUTH_INFO_FAILED = '@@dashboard/CHECK_AUTH_INFO_FAILED'
export const GET_CUSTOMERS_CHART = '@@dashboard/GET_CUSTOMERS_CHART'
export const GET_CUSTOMERS_CHART_SUCCESS =
  '@@dashboard/GET_CUSTOMERS_CHART_SUCCESS'
export const GET_CUSTOMERS_CHART_FAILED =
  '@@dashboard/GET_CUSTOMERS_CHART_FAILED'
export const GET_INVOICE_CHART = '@@dashboard/GET_INVOICE_CHART'
export const GET_INVOICE_CHART_SUCCESS = '@@dashboard/GET_INVOICE_CHART_SUCCESS'
export const GET_INVOICE_CHART_FAILED = '@@dashboard/GET_INVOICE_CHART_FAILED'
export const GET_USER_TAX_INFO = '@@dashboard/GET_USER_TAX_INFO'
export const GET_USER_TAX_INFO_SUCCESS = '@@dashboard/GET_USER_TAX_INFO_SUCCESS'
export const GET_COMPANY_UPDATES = '@@dashboard/GET_COMPANY_UPDATES'
export const GET_COMPANY_UPDATES_SUCCESS =
  '@@dashboard/GET_COMPANY_UPDATES_SUCCESS'

export const GET_INVOICE_AND_SALARY_DETAIL_MONTHLY =
  '@dashboard/GET_INVOICE_AND_SALARY_DETAIL_MONTHLY'
export const GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS =
  '@dashboard/GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_SUCCESS'
export const GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_FAILED =
  '@dashboard/GET_INVOICE_AND_SALARY_DETAIL_MONTHLY_FAILED'
export const GET_RENEW_TOKEN = '@@dashboard/GET_RENEW_TOKEN'
export const TOKEN_VALIDATION = '@@dashboard/TOKEN_VALIDATION'
export const SET_READ_COMPANY_UPDATE = 'SET_READ_COMPANY_UPDATE'
export const SET_READ_COMPANY_UPDATE_SUCCESS = 'SET_READ_COMPANY_UPDATE_SUCCESS'
export const SET_READ_COMPANY_UPDATE_FAILED = 'SET_READ_COMPANY_UPDATE_FAILED'
export const GET_USER_COMPANY_UPDATE_INFO = 'GET_USER_COMPANY_UPDATE_INFO'
export const GET_USER_COMPANY_UPDATE_INFO_SUCCESS =
  'GET_USER_COMPANY_UPDATE_INFO_SUCCESS'
export const GET_USER_COMPANY_UPDATE_INFO_FAILED =
  'GET_USER_COMPANY_UPDATE_INFO_FAILED'
export const GET_USER_LIFETIME_INFO = '@@dashboard/GET_USER_LIFETIME_INFO'
export const GET_USER_LIFETIME_INFO_SUCCESS =
  '@@dashboard/GET_USER_LIFETIME_INFO_SUCCESS'
export const GET_USER_LIFETIME_INFO_FAILED =
  '@@dashboard/GET_USER_LIFETIME_INFO_FAILED'
export const UPDATE_CELEBRATE_STATUS = 'UPDATE_CELEBRATE_STATUS'
export const UPDATE_CELEBRATE_STATUS_SUCCESS = 'UPDATE_CELEBRATE_STATUS_SUCCESS'
export const UPDATE_CELEBRATE_STATUS_FAILED = 'UPDATE_CELEBRATE_STATUS_FAILED'

// KAS-336 Referral program
export const SEND_REFERRAL = '@@dashboard/SEND_REFERRAL'
export const SEND_REFERRAL_SUCCESS = '@@dashboard/SEND_REFERRAL_SUCCESS'
export const SEND_REFERRAL_FAILED = '@@dashboard/SEND_REFERRAL_FAILED'
export const CLOSE_REFERRAL_SNACKBAR = '@@dashboard/CLOSE_REFERRAL_SNACKBAR'
export const EMAIL_REFERRED_OR_REGISTERED =
  '@@dashboard/EMAIL_REFERRED_OR_REGISTERED'
// Get referral discount by email
export const GET_REFERRAL_DISCOUNT_BY_EMAIL = 'GET_REFERRAL_DISCOUNT_BY_EMAIL'
export const GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS =
  'GET_REFERRAL_DISCOUNT_BY_EMAIL_SUCCESS'
export const GET_REFERRAL_DISCOUNT_BY_EMAIL_FAILED =
  'GET_REFERRAL_DISCOUNT_BY_EMAIL_FAILED'
export const CLOSE_DIALOG_DASHBOARD = 'CLOSE_DIALOG_DASHBOARD'
export const CLOSE_DIALOG_SALARY = 'CLOSE_DIALOG_SALARY'
export const CLOSE_SALARY_SNACKBAR = 'CLOSE_SALARY_SNACKBAR'
// Send referral code
export const SEND_REFERRAL_CODE = 'SEND_REFERRAL_CODE'
export const SEND_REFERRAL_CODE_SUCCESS = 'SEND_REFERRAL_CODE_SUCCESS'
export const SEND_REFERRAL_CODE_FAILED = 'SEND_REFERRAL_CODE_FAILED'
// Get Referral Discount Details when pay salary with discount
export const GET_REFERRAL_DISCOUNT_DETAILS_SUCCESS =
  'GET_REFERRAL_DISCOUNT_DETAILS_SUCCESS'
export const GET_REFERRAL_DISCOUNT_DETAILS_FAILED =
  'GET_REFERRAL_DISCOUNT_DETAILS_FAILED'

// Send this when people ignore the discount by pay for 5th invoice salary
export const DISCOUNT_IS_NOT_USED = 'DISCOUNT_IS_NOT_USED'
export const DISCOUNT_IS_NOT_USED_SUCCESS = 'DISCOUNT_IS_NOT_USED_SUCCESS'
export const DISCOUNT_IS_NOT_USED_FAILED = 'DISCOUNT_IS_NOT_USED_FAILED'

// end

export const SWITCH_AUTH_FORM = '@@redux-auth/SWITCH_AUTH_FORM'

export const POST_TAX_CARD = '@@tax-saga/POST_TAX_CARD' //remove
export const UPDATE_TAX_CARD_SUCCESS = '@@tax/UPDATE_TAX_CARD_SUCCESS' //remove
export const UPDATE_TAX_CARD_FAILED = '@@tax/UPDATE_TAX_CARD_FAILED' // remove
export const CLOSE_TAX_CARD_SNACKBAR = '@@tax/CLOSE_TAX_CARD_SNACKBAR'
export const CLOSE_TAX_CARD_ERROR_SNACKBAR =
  '@@tax/CLOSE_TAX_CARD_ERROR_SNACKBAR'
export const CLOSE_TAX_CARD_SPINNER = '@@tax/CLOSE_TAX_CARD_SPINNER'
export const GET_TAX_CARD = '@@tax/GET_TAX_CARD'
export const UPDATE_TAX_CARD = '@@tax/UPDATE_TAX_CARD'
export const POST_YEL_START = '@@tax/POST_YEL_START'
export const GET_YEL_START = '@@tax/GET_YEL_START'
export const GET_USER_YEL_INFO = '@@tax/GET_USER_YEL_INFO'
export const GET_YEL_SUCCESS = '@@tax/GET_YEL_SUCCESS'
export const GET_YEL_FAILED = '@@tax/GET_YEL_FAILED'
export const CLOSE_PASSWORD_SNACKBAR = '@@tax/CLOSE_PASSWORD_SNACKBAR'
export const CLOSE_YEL_SNACKBAR = '@@tax/CLOSE_YEL_SNACKBAR'
export const ENABLE_YEL_INCOME_LOCK = '@@tax/ENABLE_YEL_INCOME_LOCK'
export const ENABLE_YEL_SELECTION_LOCK = '@@tax/ENABLE_YEL_SELECTION_LOCK'

export const GET_INVOICES_START = '@@invoice-saga/GET_INVOICES_START'
export const GET_INVOICES_SUCCESS = '@@invoice-saga/GET_INVOICES_SUCCESS'
export const GET_INVOICES_FAILED = '@@invoice-saga/GET_INVOICE_FAILED'

export const GET_PROFESSION = '@@profile-saga/GET_PROFESSION'
export const GET_PROFESSION_SUCCESS = '@@profile-saga/GET_PROFESSION_SUCCESS'
export const GET_PROFESSION_FAILED = '@@profile-saga/GET_PROFESSION_FAILED'
export const GET_FIELD_OF_WORK = 'GET_FIELD_OF_WORK'
export const GET_FIELD_OF_WORK_SUCCESS = 'GET_FIELD_OF_WORK_SUCCESS'
export const GET_FINVOICE_OPERATOR = '@@invoice-saga/GET_FINVOICE_OPERATOR'
export const GET_OPERATOR_SUCCESS = '@@invoice-saga/GET_OPERATOR_SUCCESS'
export const GET_OPERATOR_FAILED = '@@invoice-saga/GET_OPERATOR_FAILED'

export const SAVE_INVOICE_SUCCESS = '@@invoice-saga/SAVE_INVOICE_SUCCESS'
export const REVIEW_INVOICE_EDIT_SUCCESS =
  '@@invoice-saga/REVIEW_INVOICE_EDIT_SUCCESS'
export const REVIEW_INVOICE_EDIT_SEND_SUCCESS =
  '@@invoice-saga/REVIEW_INVOICE_EDIT_SEND_SUCCESS'
export const UPDATE_INVOICE_FAILED = '@@invoice-saga/UPDATE_INVOICE_FAILED'
export const SAVE_INVOICE_FAILED = '@@invoice-saga/SAVE_INVOICE_FAILED'
export const LOAD_INVOICES_START = '@@invoice-saga/LOAD_INVOICES_START'

export const GO_TO_REVIEW = '@@invoice/GO_TO_REVIEW'
export const GO_TO_INVOICE = '@@invoice/GO_TO_INVOICE'
export const EDIT_AND_GO_TO_INVOICE = '@@invoice/EDIT_AND_GO_TO_INVOICE'
export const DISABLE_CANCEL_INVOICE = '@@invoice/DISABLE_CANCEL_INVOICE'
export const ENABLE_CANCEL_INVOICE = '@@invoice/ENABLE_CANCEL_INVOICE'
export const UPDATE_INVOICE_SUMS = '@@invoice/UPDATE_INVOICE_SUMS'
export const CHANGE_INVOICE_BILLING_DATE =
  '@@invoice/CHANGE_INVOICE_BILLING_DATE'
export const COPY_INVOICE = '@@invoice/COPY_INVOICE'
export const COPY_INVOICE_SUCCESS = '@@invoice/COPY_INVOICE_SUCCESS'
export const REMOVE_INVOICE = '@@invoice/REMOVE_INVOICE'
export const WARN_INVOICE_TO_DELETE = '@@invoice/WARN_INVOICE_TO_DELETE'
export const REMINDER_INVOICE_DOWNLOAD_PDF =
  '@@invoice/REMINDER_INVOICE_DOWNLOAD_PDF'
export const CANCEL_DELETE_INVOICE = '@@invoice/CANCEL_DELETE_INVOICE'

export const EDIT_INVOICE = '@@invoice/EDIT_INVOICE'
export const CANCEL_EDIT_INVOICE = '@@invoice/CANCEL_EDIT_INVOICE'
export const INVOICE_EDIT_SUCCESS = '@@invoice/INVOICE_EDIT_SUCCESS'
export const CLEAR_INVOICE_EDIT_VALUES = '@@profile/CLEAR_INVOICE_EDIT_VALUES'
export const GET_INVOICE_BY_ID_SUCCESS = '@@invoice/GET_INVOICE_BY_ID_SUCCESS'
export const CALCULATE_INVOICE_DUEDATE = '@@invoice/CALCULATE_INVOICE_DUEDATE'
export const REMOVE_INVOICE_ROW = '@@invoice/REMOVE_INVOICE_ROW'
export const SAVE_AND_SEND_INVOICE = '@@invoice/SAVE_AND_SEND_INVOICE'
export const SHOW_TOOLTIP = '@@invoice/SHOW_TOOLTIP'
export const HIDE_TOOLTIP = '@@invoice/HIDE_TOOLTIP'
export const QUANTITY_CHANGE = '@@invoice/QUANTITY_CHANGE'
export const QUANTITY_PRICE_CHANGE = '@@invoice/QUANTITY_PRICE_CHANGE'
export const ON_INVOICE_REVIEW = '@@invoice/ON_INVOICE_REVIEW'
export const CLOSE_INVOICE_REVIEW_SNACKBAR =
  '@@invoice/CLOSE_INVOICE_REVIEW_SNACKBAR'
export const SAVE_INVOICE_DRAFT = '@@invoice/SAVE_INVOICE_DRAFT'
export const DOWNLOAD_PDF_SUCCESS = '@@invoice/DOWNLOAD_PDF_SUCCESS'
export const DOWNLOAD_PDF_FAILED = '@@invoice/DOWNLOAD_PDF_FAILED'
export const GENERATE_INVOICE_PDF = '@@invoice/GENERATE_INVOICE_PDF'
export const INVOICE_DOWNLOAD_PDF = '@@invoice/INVOICE_DOWNLOAD_PDF'
export const ADD_CREDIT_NOTE_INVOICE = '@@invoice/ADD_CREDIT_NOTE_INVOICE'
export const ADD_CREDIT_NOTE_SUCCESS = '@@invoice/ADD_CREDIT_NOTE_SUCCESS'
export const ADD_CREDIT_NOTE_FAILED = '@@invoice/ADD_CREDIT_NOTE_FAILED'
export const SET_ORIGINAL_INVOICE_ID = '@@invoice/SET_ORIGINAL_INVOICE_ID'
export const NAVIGATE_TO_UPDATE_BANK_INFO =
  '@@invoice/NAVIGATE_TO_UPDATE_BANK_INFO'
export const CHANGE_VAT_PERCENT = '@invoice/CHANGE_VAT_PERCENT'
export const CANCEL_EXPENSE_REMINDER = '@invoice/CANCEL_EXPENSE_REMINDER'
export const SELECT_INVOICE_CUSTOMER = '@@invoice/SELECT_INVOICE_CUSTOMER'
export const CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID =
  '@@invoice/CLEAR_ATTACH_WORKSHIFT_JOURNAL_ID'
export const ATTACH_WORKSHIFT_JOURNAL_ID =
  '@@invoice/ATTACH_WORKSHIFT_JOURNAL_ID'
export const ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS =
  '@@invoice/ATTACH_WORKSHIFT_JOURNAL_ID_SUCCESS'
export const UPDATE_ATTACH_JOURNAL_TO_INVOICE =
  '@@invoice/UPDATE_ATTACH_JOURNAL_TO_INVOICE'
export const UPDATE_ATTACH_JOURNAL_TO_INVOICE_SUCCESS =
  '@@invoice/UPDATE_ATTACH_JOURNAL_TO_INVOICE_SUCCESS'
export const UPDATE_ATTACH_JOURNAL_TO_INVOICE_FAILED =
  '@@invoice/UPDATE_ATTACH_JOURNAL_TO_INVOICE_FAILED'
export const GET_ATTACHED_JOURNAL_PDF_DATA =
  '@@invoice/GET_ATTACHED_JOURNAL_PDF_DATA'

export const GET_EXPENSE_START = '@@expense/GET_EXPENSE_START'
export const GET_EXPENSE_SUCCESS = '@@expense/GET_EXPENSE_SUCCESS'
export const GET_EXPENSE_FAILED = '@@expense/GET_EXPENSE_FAILED'
export const CALCULATE_DISTANCE = '@@expense/CALCULATE_DISTANCE'
export const CLEAR_ADDITIONAL_VEHICLE_INFO =
  '@@expense/CLEAR_ADDITIONAL_VEHICLE_INFO'
export const SAVE_EXPENSE = '@@expense/SAVE_EXPENSE'
export const SAVE_EXPENSE_FAILED = '@@expense/SAVE_EXPENSE_FAILED'
export const SAVE_EXPENSE_SUCCESS = '@@expense/SAVE_EXPENSE_SUCCESS'
export const EMPTY_EXPENSE_ROWS = '@@expense/EMPTY_EXPENSE_ROWS'
export const CLOSE_EXPENSE_SNACKBAR = '@@expense/CLOSE_EXPENSE_SNACKBAR'
export const EXPENSE_CHANGE_PAGE = '@@expense/EXPENSE_CHANGE_PAGE'
export const SAVE_ALLOWANCE = '@@travelling-expense/SAVE_ALLOWANCE'
export const SAVE_ALLOWANCE_SUCCESS =
  '@@travelling-expense/SAVE_ALLOWANCE_SUCCESS'
export const SAVE_ALLOWANCE_FAILED =
  '@@travelling-expense/SAVE_ALLOWANCE_FAILED'
export const LOAD_ALLOWANCE_COST = '@@travelling-expense/LOAD_ALLOWANCE_COST'
export const LOAD_ALLOWANCE_COST_SUCCESS =
  '@@traveling-expense/LOAD_ALLOWANCE_COST_SUCCESS'
export const LOAD_ALLOWANCE_COST_FAILED =
  '@@travelling-expense/LOAD_ALLOWANCE_COST_FAILED'
export const ALLOWANCE_CHANGE_PAGE = '@@expense/ALLOWANCE_CHANGE_PAGE'
export const REMOVE_EXPENSE = '@@expense/REMOVE_EXPENSE'
export const REMOVE_ALLOWANCE = '@@expense/REMOVE_ALLOWANCE'
export const EDIT_EXPENSE = '@@expense/EDIT_EXPENSE'
export const EDIT_ALLOWANCE = '@@expense/EDIT_ALLOWANCE'
export const SELECT_EXPENSE_ID = '@@expense/SELECT_EXPENSE_ID'
export const SELECT_ALLOWANCE_ID = '@@expense/SELECT_ALLOWANCE_ID'
export const CLOSE_EXP_INVOICE_WARN_SNACK_BAR =
  '@@expense/CLOSE_EXP_INVOICE_WARN_SNACK_BAR'
//export const CLOSE_EXP_INVOICE_SNACK_BAR='@@expense/CLOSE_EXP_INVOICE_SNACK_BAR'
export const RESET_EXPENSE_ALLOWANCE_SELECTION =
  '@@expense/RESET_EXPENSE_ALLOWANCE_SELECTION'
export const CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR =
  '@@expense/CLOSE_ALLOWANCE_INVOICE_WARN_SNACK_BAR'
//export const CLOSE_ALLOWANCE_INVOICE_SNACK_BAR='@@expense/CLOSE_ALLOWANCE_INVOICE_SNACK_BAR'
export const GET_EXPENSE_BY_ID_SUCCESS = '@@expense/GET_EXPENSE_BY_ID_SUCCESS'
export const GET_ALLOWANCE_BY_ID_SUCCESS =
  '@@expense/GET_ALLOWANCE_BY_ID_SUCCESS'
export const SAVE_EXPENSE_UPDATE = '@@expense/SAVE_EXPENSE_UPDATE'
export const CANCEL_EXPENSE_UPDATE = '@@expense/CANCEL_EXPENSE_UPDATE'
export const SAVE_ALLOWANCE_UPDATE = '@@expense/SAVE_ALLOWANCE_UPDATE'
export const CANCEL_ALLOWANCE_UPDATE = '@@expense/CANCEL_ALLOWANCE_UPDATE'
export const CHANGE_PURCHASE_DATE = '@@expense/CHANGE_PURCHASE_DATE'
export const EXPENSE_UPDATE_SUCCESS = '@@expense/EXPENSE_UPDATE_SUCCESS'
export const EXPENSE_UPDATE_FAILED = '@@expense/EXPENSE_UPDATE_FAILED'
export const ALLOWANCE_UPDATE_SUCCESS = '@@expense/ALLOWANCE_UPDATE_SUCCESS'
export const ALLOWANCE_UPDATE_FAILED = '@@expense/ALLOWANCE_UPDATE_FAILED'
export const ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED =
  '@@expense/ALLOWANCE_UPDATE_EXCEED_LIMIT_FAILED'
export const EMPTY_PASSENGER_ROWS = '@@expense/EMPTY_PASSENGER_ROWS'
export const EMPTY_ALLOWANCE_INPUT_ROWS = '@@expense/EMPTY_ALLOWANCE_INPUT_ROWS'

export const UPDATE_INVOICEID_TO_INFO_SUCCESS =
  '@@expense/UPDATE_INVOICEID_TO_INFO_SUCCESS'
export const UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED =
  '@@expense/UPDATE_INVOICEID_TO_INFO_EXCEED_LIMIT_FAILED'
export const UPDATE_INVOICEID_TO_INFO_FAILED =
  '@@expense/UPDATE_INVOICEID_TO_INFO_FAILED'

export const UPDATE_SELECTED_EXPENSE_IDS =
  '@@expense/UPDATE_SELECTED_EXPENSE_IDS'
export const UPDATE_EXPENSE_SELECTED_LIST =
  '@@expense/UPDATE_EXPENSE_SELECTED_LIST'
export const UPDATE_SELECTED_ALLOWANCE_IDS =
  '@@expense/UPDATE_SELECTED_ALLOWANCE_IDS'

export const UPDATE_PROFILE = '@@profile/UPDATE_PROFILE'
export const LOAD_PROFILE_SUCCESS = '@@profile/LOAD_PROFILE_SUCCESS'
export const LOAD_PROFILE_FAILED = '@@profile/LOAD_PROFILE_FAILED'
export const LOAD_PROFILE_START = '@@profile/LOAD_PROFILE_START'
export const UPDATE_PROFILE_SUCCESS = '@@profile/UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILED = '@@profile/UPDATE_PROFILE_FAILED'
export const CLOSE_PROFILE_SNACKBAR = '@@profile/CLOSE_PROFILE_SNACKBAR'
export const ON_PASSWORD_UPDATE = '@@profile/ON_PASSWORD_UPDATE'
export const PASSWORD_UPDATE_SUCCESS = '@@profile/PASSWORD_UPDATE_SUCCESS'
export const PASSWORD_UPDATE_FAILED = '@@profile/PASSWORD_UPDATE_FAILED'
export const YEL_UPDATE_SUCCESS = '@@profile/YEL_UPDATE_SUCCESS'
export const YEL_UPDATE_FAILED = '@@profile/YEL_UPDATE_FAILED'
export const LOAD_USER_YEL_INFO_SUCCESS = '@@profile/LOAD_USER_YEL_INFO_SUCCESS'
export const LOAD_USER_YEL_INFO_FAILED = '@@profile/LOAD_USER_YEL_INFO_FAILED'
export const RESET_SCROLL_TO_SSN = '@@profile/RESET_SCROLL_TO_SSN'
export const SSN_DUPLICATE = '@@profile/SSN_DUPLICATE' //KAS-361 SSN Duplicate warning

export const ADD_NEW_CUSTOMER = '@@customer/NEW_CUSTOMER'
export const ADD_CUSTOMER_SUCCESS = '@@customer/ADD_CUSTOMER_SUCCESS'
export const ADD_CUSTOMER_FAILED = '@@customer/ADD_CUSTOMER_FAILED'
export const OPEN_CUSTOMER_FORM_DIALOG = '@@customer/OPEN_CUSTOMER_FORM_DIALOG'
export const CLOSE_CUSTOMER_FORM_DIALOG =
  '@@customer/CLOSE_CUSTOMER_FORM_DIALOG'
export const GET_EINVOICE_OPERATOR = '@@customer/GET_EINVOICE_OPERATOR'
export const GET_EOPERATOR_SUCCESS = '@@customer/GET_EOPERATOR_SUCCESS'
export const GET_EOPERATOR_FAILED = '@@customer/GET_EOPERATOR_FAILED'
export const REMOVE_CUSTOMER = '@@customer-saga/REMOVE_CUSTOMER'
export const GET_CUSTOMER_BY_ID = '@@customer-saga/GET_CUSTOMER_BY_ID'
export const GET_CUSTOMER_BY_ID_SUCCESS =
  '@@customer-saga/GET_CUSTOMER_BY_ID_SUCCESS'
export const SAVE_CUSTOMER_UPDATE = '@@customer-saga/SAVE_CUSTOMER_UPDATE'
export const CANCEL_CUSTOMER_UPDATE = '@@customer/CANCEL_CUSTOMER_UPDATE'
export const ADD_NEW_CUSTOMER_INVOICE = '@@customer/ADD_NEW_CUSTOMER_INVOICE'
export const ADD_NEW_CUSTOMER_INVOICE_SUCCESS =
  '@@customer/ADD_NEW_CUSTOMER_INVOICE_SUCCESS'
export const CLOSE_CUSTOMER_SNACKBAR = '@@customer/CLOSE_CUSTOMER_SNACKBAR'
export const WARN_CUSTOMER_TO_DELETE = '@@customer/WARN_CUSTOMER_TO_DELETE'
export const CANCEL_DELETE_CUSTOMER = '@@customer/CANCEL_DELETE_CUSTOMER'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export const GET_CUSTOMERS_START = '@@customer-saga/GET_CUSTOMERS_START'
export const GET_CUSTOMERS_SUCCESS = '@@customer-saga/GET_CUSTOMERS_SUCCESS'

export const CUSTOMER_PAGE_CHANGE = '@@customer/CUSTOMER_PAGE_CHANGE'
export const INVOICE_PAGE_CHANGE = '@@invoice/INVOICE_PAGE_CHANGE'
export const CHANGE_ADMIN_MENU = '@@admin/CHANGE_ADMIN_MENU'
export const SEARCH_ADMIN_USERS = '@@admin/SEARCH_ADMIN_USERS'
export const SEARCH_ADMIN_USERS_SUCCESS = '@@admin/SEARCH_ADMIN_USERS_SUCCESS'
export const SEARCH_ADMIN_USERS_FAILED = '@@admin/SEARCH_ADMIN_USERS_FAILED'
export const CLOSE_ADMIN_USER_FORMS = '@@admin/CLOSE_ADMIN_USER_FORMS'
export const CLOSE_ADMIN_USER_FORMS_SUCCESS =
  '@@admin/CLOSE_ADMIN_USER_FORMS_SUCCESS'
export const EXPAND_ADMIN_USER = '@@admin/EXPAND_ADMIN_USER'
export const EXPAND_ADMIN_USER_TRUE = '@@admin/EXPAND_ADMIN_USER_TRUE'
export const EXPAND_ADMIN_USER_FALSE = '@@admin/EXPAND_ADMIN_USER_FALSE'
export const UPDATE_ADMIN_USER = '@@admin/UPDATE_ADMIN_USER'
export const UPDATE_ADMIN_USER_RESULT = '@@admin/UPDATE_ADMIN_USER_RESULT'
export const UPDATE_ADMIN_USER_RESULT_FAILED =
  '@@admin/UPDATE_ADMIN_USER_RESULT_FAILED'
export const SEARCH_ADMIN_INVOICE = '@@admin/SEARCH_ADMIN_INVOICE'
export const SEARCH_ADMIN_INVOICE_SUCCESS =
  '@@admin/SEARCH_ADMIN_INVOICE_SUCCESS'
export const SEARCH_ADMIN_INVOICE_FAILED = '@@admin/SEARCH_ADMIN_INVOICE_FAILED'
export const EXPAND_ADMIN_INVOICE = '@@admin/EXPAND_ADMIN_INVOICE'
export const EXPAND_ADMIN_INVOICE_TRUE = '@@admin/EXPAND_ADMIN_INVOICE_TRUE'
export const EXPAND_ADMIN_INVOICE_FALSE = '@@admin/EXPAND_ADMIN_INVOICE_FALSE'
export const UPDATE_ADMIN_INVOICE = '@@admin/UPDATE_ADMIN_INVOICE'
export const UPDATE_ADMIN_INVOICE_RESULT = '@@admin/UPDATE_ADMIN_INVOICE_RESULT'
export const UPDATE_ADMIN_INVOICE_RESULT_FAILED =
  '@@/UPDATE_ADMIN_INVOICE_RESULT_FAILED'
export const ADMIN_GENERATE_PDF_FAILED = '@@admin/ADMIN_GENERATE_PDF_FAILED'
export const SHOW_LATEST_INVOICE_PDF = '@@admin/SHOW_LATEST_INVOICE_PDF'
export const CLOSE_ADMIN_INVOICE_FORMS = '@@admin/CLOSE_ADMIN_INVOICE_FORMS'
export const CLOSE_ADMIN_INVOICE_FORMS_SUCCESS =
  '@@admin/CLOSE_ADMIN_INVOICE_FORMS_SUCCESS'
export const HIDE_ADMIN_SNACKBAR = '@@admin/HIDE_ADMIN_SNACKBAR'
export const SEARCH_ADMIN_IR = '@@admin/SEARCH_ADMIN_IR'
export const SEARCH_ADMIN_WAGES = '@@admin/SEARCH_ADMIN_WAGES'
export const SEARCH_ADMIN_WAGES_SUCCESS = '@@admin/SEARCH_ADMIN_WAGES_SUCCESS'
export const SEARCH_ADMIN_WAGES_FAILED = '@@admin/SEARCH_ADMIN_WAGES_FAILED'
export const SEARCH_ADMIN_WAGES_IR_SUCCESS =
  '@@admin/SEARCH_ADMIN_WAGES_IR_SUCCESS'
export const SEARCH_ADMIN_WAGES_IR_FALIED =
  '@@admin/SEARCH_ADMIN_WAGES_IR_FALIED'
export const UPDATE_ADMIN_INVOICE_STATUS = '@@admin/UPDATE_ADMIN_INVOICE_STATUS'
export const UPDATE_ADMIN_SALARY_STATUS = '@admin/UPDATE_ADMIN_SALARY_STATUS'
export const ADMIN_ADD_NEW_UPDATES = '@admin/ADMIN_ADD_NEW_UPDATES'
export const ADMIN_ADD_NEW_UPDATES_SUCCESS =
  '@admin/ADMIN_ADD_NEW_UPDATES_SUCCESS'
export const ADMIN_DELETE_COMPANY_UPDATE = '@admin/ADMIN_DELETE_COMPANY_UPDATE'
export const ADMIN_DELETE_COMPANY_UPDATE_SUCCESS =
  '@admin/ADMIN_DELETE_COMPANY_UPDATE_SUCCESS'
export const ADMIN_GET_UPDATES = '@@admin/ADMIN_GET_UPDATES'
export const ADMIN_GET_UPDATES_SUCCESS = '@@admin/ADMIN_GET_UPDATES_SUCCESS'
export const NO_PIKAPALKKA = '@@admin/NO_PIKAPALKKA'
export const SHOW_SALARY_PDF = '@@admin/SHOW_SALARY_PDF'
export const SHOW_INVOICE_PDF = '@@admin/SHOW_INVOICE_PDF'
export const SHOW_REMINDER_INVOICE_PDF = '@@admin/SHOW_REMINDER_INVOICE_PDF'
export const GET_ADMIN_EXPENSE_REPORT = '@@admin/GET_ADMIN_EXPENSE_REPORT'
export const INVOICE_SEARCH_PAGE_CHANGE = '@@admin/INVOICE_SEARCH_PAGE_CHANGE'
export const SALARY_SEARCH_PAGE_CHANGE = '@@admin/SALARY_SEARCH_PAGE_CHANGE'
export const IR_SEARCH_PAGE_CHANGE = '@@admin/IR_SEARCH_PAGE_CHANGE'
export const USER_SEARCH_PAGE_CHANGE = '@@admin/USER_SEARCH_PAGE_CHANGE'
export const TIEDOTTEET_SEARCH_PAGE_CHANGE =
  '@@admin/TIEDOTTEET_SEARCH_PAGE_CHANGE'
export const RELEASE_INFO_SEARCH_PAGE_CHANGE =
  '@@dashboard/RELEASE_INFO_SEARCH_PAGE_CHANGE'
export const WARN_INVOICE_TO_PAY = '@@admin/WARN_INVOICE_TO_PAY'
export const WARN_SALARY_TO_PAY = '@@admin/WARN_SALARY_TO_PAY'
export const CONFIRM_SALARY_TO_PAY = '@@admin/CONFIRM_SALARY_TO_PAY'
export const CANCEL_UPDATE_ADMIN_INVOICE_STATUS =
  '@@admin/CANCEL_UPDATE_ADMIN_INVOICE_STATUS'
export const CLOSE_DIALOG = '@@admin/CLOSE_DIALOG'
export const CANCEL_UPDATE_ADMIN_SALARY_STATUS =
  '@@admin/CANCEL_UPDATE_ADMIN_SALARY_STATUS'
export const REMOVE_PAYMENT_DIALOG = '@@admin/REMOVE_PAYMENT_DIALOG'
export const CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS =
  '@@admin/CANCEL_UPDATE_ADMIN_SALARY_STATUS_SUCCESS'
export const UPDATE_ADMIN_INVOICE_STATUS_SUCCESS =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_SUCCESS'
export const UPDATE_ADMIN_SALARY_STATUS_SUCCESS =
  '@@admin/UPDATE_ADMIN_SALARY_STATUS_SUCCESS'
export const UPDATE_ADMIN_SALARY_STATUS_FAILED =
  '@@admin/UPDATE_ADMIN_SALARY_STATUS_FAILED'
export const UPDATE_ADMIN_INVOICE_STATUS_REJECTED =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_REJECTED'
export const UPDATE_ADMIN_INVOICE_STATUS_NEW =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_NEW'

export const UPDATE_ADMIN_INVOICE_STATUS_LOANED =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_LOANED'
export const UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_NOT_ACCEPTED'
export const UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_PAID_AND_NEW_INVOICE'
export const UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA =
  '@@admin/UPDATE_ADMIN_INVOICE_STATUS_PERINNASSA'
export const SENT_INVOICE_REMINDER = '@@admin/SENT_INVOICE_REMINDER'
export const IMPORT_KASSAVIRTANEN_SALARIES =
  '@@admin/IMPORT_KASSAVIRTANEN_SALARIES'
export const SALARY_SEND_TO_IR = '@@admin/SALARY_SEND_TO_IR'
export const CANCEL_SALARY_IR_REPORT = '@@admin/CANCEL_SALARY_IR_REPORT'
export const MANUAL_PAY_SALARIES = '@@admin/MANUAL_PAY_SALARIES'
export const UPDATE_ADMIN_BANK_PAYMENT_SUCCESS =
  '@@admin/UPDATE_ADMIN_BANK_PAYMENT_SUCCESS'
export const UPDATE_ADMIN_BANK_PAYMENT_FAILED =
  '@@admin/UPDATE_ADMIN_BANK_PAYMENT_FAILED'
export const UPDATE_ADMIN_IR_FAILED = '@@admin/UPDATE_ADMIN_IR_FAILED'
export const GET_ADMIN_EXPENSE_REPORT_SUCCESS =
  '@@admin/GET_ADMIN_EXPENSE_REPORT_SUCCESS'
export const GET_ADMIN_EXPENSE_REPORT_FAILED =
  '@@admin/GET_ADMIN_EXPENSE_REPORT_FAILED'
export const UPDATE_ADMIN_SALARY_STATUS_IR =
  '@@admin/UPDATE_ADMIN_SALARY_STATUS_IR'
export const UPDATE_ADMIN_TABLE = '@@admin/UPDATE_ADMIN_TABLE'
export const UPDATE_ADMIN_TABLE_SUCCESS = '@@admin/UPDATE_ADMIN_TABLE_SUCCESS'
export const SEARCH_COMPANY_CUSTOMERS = '@@admin/SEARCH_COMPANY_CUSTOMERS'
export const SEARCH_COMPANY_INVOICES = '@@admin/SEARCH_COMPANY_INVOICES'
export const SEARCH_COMPANY_SALARIES = '@@admin/SEARCH_COMPANY_SALARIES'
export const GET_ADMIN_SALARY_ULOSOTTO_INFO =
  '@@admin/GET_ADMIN_SALARY_ULOSOTTO_INFO'
export const GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS =
  '@@admin/GET_ADMIN_SALARY_ULOSOTTO_INFO_SUCCESS'

// KAS-337 search all admin invoices rows when startdate and enddate  are searched
export const SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS =
  '@@admin/SEARCH_ADMIN_INVOICE_ALL_ROWS_SUCCESS'

// PI-296 Fetching all salary rows
export const SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS =
  '@@admin/SEARCH_ADMIN_SALARY_ALL_RECORDS_SUCCESS'

// KAS-344 update industry tax card at Admin
export const ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS =
  '@@admin/ADMIN_UPDATE_INDUSTRY_TAX_CARD_SUCCESS'
export const ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED =
  '@@admin/ADMIN_UPDATE_INDUSTRY_TAX_CARD_FAILED'

export const GET_NEW_SALARY_START = '@@salary/GET_NEW_SALARY_START'
export const GET_NEW_SALARY_SUCCESS = '@@salary/GET_NEW_SALARY_SUCCESS'
export const SELECT_ROW_SALARY = '@@salary/SELECT_ROW_SALARY'
export const SELECT_ROW_SALARY_SUCCESS = '@@salary/SELECT_ROW_SALARY_SUCCESS'
export const CLEAR_SALARY_SELECTION = '@@salary/CLEAR_SALARY_SELECTION'
export const GET_SALARIES_START = '@@salary/GET_SALARIES_START'
export const GET_SALARIES_SUCCESS = '@@salary/GET_SALARIES_SUCCESS'
export const POST_SALARY = '@@salary/POST_SALARY'
export const GET_SALARY_INFO = '@@salary/GET_SALARY_INFO'
export const GET_SALARY_BY_ID_SUCCESS = '@@salary/GET_SALARY_BY_ID_SUCCESS'
export const SALARY_PAGE_CHANGE = '@@salary/SALARY_PAGE_CHANGE'
export const SAVE_SALARY_SLIP = '@@salary/SAVE_SALARY_SLIP'
export const CANCEL_PAY_SALARY = '@@salary/CANCEL_PAY_SALARY'
export const ADD_SALARY_SUCCESS = '@@salary/ADD_SALARY_SUCCESS'
export const ADD_SALARY_FAILURE = '@@salary/ADD_SALARY_FAILURE'
export const CLOSE_SALARY_PAY_ERROR = '@@salary/CLOSE_SALARY_PAY_ERROR'
export const WARN_TO_ADD_COST = '@@salary/WARN_TO_ADD_COST'
export const WARN_NO_SSN = '@@salary/WARN_NO_SSN'

export const LANGUAGE_CHANGE = '@@lang/LANGUAGE_CHANGE'
export const SAVE_AND_SEND_INVOICE_PDF = '@invoice/SAVE_AND_SEND_INVOICE_PDF'
export const SAVE_AND_SEND_INVOICE_SUCCESS =
  '@invoice/SAVE_AND_SEND_INVOICE_SUCCESS'
export const GENERATE_INVOICE_PDF_SUCCESS =
  '@invoice/GENERATE_INVOICE_PDF_SUCCESS'
export const GENERATE_INVOICE_PDF_FAILED =
  '@invoice/GENERATE_INVOICE_PDF_FAILED'
export const INVOKE_EXPENSE_REMINDER = '@invoice/INVOKE_EXPENSE_REMINDER'
export const SET_INVOICE_ATTACHMENTS = '@invoice/SET_INVOICE_ATTACHMENTS'
export const REMOVE_INVOICE_ATTACHMENTS = '@invoice/REMOVE_INVOICE_ATTACHMENTS'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const OPENID_SERVER = process.env.OPENID_SERVER

export const ADD_EXPENSES_TO_INVOICE = '@@expense/ADD_EXPENSES_TO_INVOICE'
export const UPDATE_INVOICEID_TO_EXPENSE =
  '@@expense/UPDATE_INVOICEID_TO_EXPENSE'
export const ADD_ALLOWANCES_TO_INVOICE = '@@expense/ADD_ALLOWANCES_TO_INVOICE'
export const UPDATE_INVOICEID_TO_ALLOWANCE =
  '@@expense/UPDATE_INVOICEID_TO_ALLOWANCE'

export const SHOW_EXPENSE_DIALOG = '@@expense/SHOW_EXPENSE_DIALOG'
export const CANCEL_EXPENSE_DIALOG = '@@expense/CANCEL_EXPENSE_DIALOG'
export const SHOW_ALLOWANCE_DIALOG = '@@expense/SHOW_ALLOWANCE_DIALOG'
export const CANCEL_ALLOWANCE_DIALOG = '@@expense/CANCEL_ALLOWANCE_DIALOG'
export const CANCEL_INVOICE_INFO_DIALOG = '@@expense/CANCEL_INVOICE_INFO_DIALOG'

export const ENABLE_EXPENSE_BACK_BTN = '@@invoice/ENABLE_EXPENSE_BACK_BTN'
export const ENABLE_ALLOWANCE_BACK_BTN = '@@invoice/ENABLE_ALLOWANCE_BACK_BTN'

export const DISABLE_EXPENSE_BACK_BTN = '@@invoice/DISABLE_EXPENSE_BACK_BTN'
export const DISABLE_ALLOWANCE_BACK_BTN = '@@invoice/DISABLE_ALLOWANCE_BACK_BTN'

export const GET_ADMIN_USERS_LIST = '@@dashboard/GET_ADMIN_USERS_LIST'
export const GET_ADMIN_USERS_LIST_SUCCESS =
  '@@dashboard/GET_ADMIN_USERS_LIST_SUCCESS'
export const GET_ADMIN_USERS_LIST_FAIL = '@@dashboard/GET_ADMIN_USERS_LIST_FAIL'

export const SELECT_USER = '@@adminUser/SELECT_USER'
export const SELECT_USER_SUCCESS = '@@adminUser/SELECT_USER_SUCCESS'
export const SELECT_USER_FAIL = '@@adminUser/SELECT_USER_FAIL'
export const UNSELECT_USER = '@@adminUser/UNSELECT_USER'

export const GET_USER_INFO = '@@adminUser/GET_USER_INFO'
export const GET_USER_INFO_SUCCESS = '@@adminUser/GET_USER_INFO_SUCCESS'
export const GET_USER_INFO_FAIL = '@@adminUser/GET_USER_INFO_FAIL'
export const CLEAR_SELECTED_USER = '@@adminUser/CLEAR_SELECTED_USER'

export const LOAD_INVOICE_ITEMS = '@@loader/LOAD_INVOICE_ITEMS'
export const CLOSE_LOAD_INVOICE_ITEMS = '@@loader/CLOSE_LOAD_INVOICE_ITEMS'
export const LOAD_EXPENSE_ITEMS = '@@loader/LOAD_EXPENSE_ITEMS'
export const CLOSE_LOAD_EXPENSE_ITEMS = '@@loader/CLOSE_LOAD_EXPENSE_ITEMS'

export const LOAD_SALARY_ITEMS = '@@loader/LOAD_SALARY_ITEMS'
export const CLOSE_LOAD_SALARY_ITEMS = '@@loader/CLOSE_LOAD_SALARY_ITEMS'
export const ADMIN_SEND_NEW_INVOICE_SUCCESS =
  '@@loader/ADMIN_SEND_NEW_INVOICE_SUCCESS'
export const ADMIN_GENERATE_PDF_SUCCESS = '@@loader/ADMIN_GENERATE_PDF_SUCCESS'
export const UPDATE_FORM_VALUES = '@@form/UPDATE_FORM_VALUES'
export const UPDATE_FORM_SUCCESS = '@@form/UPDATE_FORM_SUCCESS'
export const RESET_FORM = '@@form/RESET_FORM'
export const RESET_FORM_SUCCESS = '@@form/RESET_FORM_SUCCESS'
export const SUBMIT_FORM_SUCCESS = '@@form/SUBMIT_FORM_SUCCESS'

export const QUICK_PAY_LIMIT = 4000.0

export const PRICE_CHANGE = 'PRICE_CHANGE'
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST'
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS'

// search company details
export const SEARCH_COMPANY_DETAILS = 'SEARCH_COMPANY_DETAILS'

export const SEARCH_COMPANY_DETAILS_SUCCESS = 'SEARCH_COMPANY_DETAILS_SUCCESS'

export const LOAD_SELECTED_COMPANY = 'LOAD_SELECTED_COMPANY'

export const CLOSE_COMPANY_LISTS = 'CLOSE_COMPANY_LISTS'

//Dashboard overview yearly graphs
export const INCREMENT_YEAR = '@@dashboard/INCREMENT_YEAR'
export const DECREMENT_YEAR = '@@dashboard/DECREMENT_YEAR'
export const RESET_YEAR = '@@dashbord/RESET_YEAR'

// Page size defaults for admin views - Select one of the following 10,20,50,100
export const ADMIN_SALARY_PAGE_SIZE = 20
export const ADMIN_INVOICE_PAGE_SIZE = 20

export const LOAD_OPEN_FOR_WORK_START = '@@openForWork/LOAD_OPEN_FOR_WORK_START'
export const LOAD_OPEN_FOR_WORK_SUCCESS =
  '@@openForWork/LOAD_OPEN_FOR_WORK_SUCCESS'
export const LOAD_OPEN_FOR_WORK_FAILED =
  '@@openForWork/LOAD_OPEN_FOR_WORK_FAILED'
export const UPDATE_OPEN_FOR_WORK = '@@openForWork/UPDATE_OPEN_FOR_WORK'
export const UPDATE_OPEN_FOR_WORK_SUCCESS =
  '@@openForWork/UPDATE_OPEN_FOR_WORK_SUCCESS'
export const UPDATE_OPEN_FOR_WORK_FAILED =
  '@@openForWork/UPDATE_OPEN_FOR_WORK_FAILED'
export const CLOSE_OPEN_FOR_WORK_SNACKBAR =
  '@@openForWork/CLOSE_OPEN_FOR_WORK_SNACKBAR'
export const GET_AREA_OF_EXPERTISE = '@@openForWork/GET_AREA_OF_EXPERTISE'
export const GET_AREA_OF_EXPERTISE_SUCCESS =
  '@@openForWork/GET_AREA_OF_EXPERTISE_SUCCESS'
export const GET_AREA_OF_WORK = '@@openForWork/GET_AREA_OF_WORK'
export const GET_AREA_OF_WORK_SUCCESS = '@@openForWork/GET_AREA_OF_WORK_SUCCESS'
export const NOT_OPEN_FOR_WORK = '@@openForWork/NOT_OPEN_FOR_WORK'
export const NOT_OPEN_FOR_WORK_SUCCESS =
  '@@openForWork/NOT_OPEN_FOR_WORK_SUCCESS'
export const NOT_OPEN_FOR_WORK_FAILED = '@@openForWork/NOT_OPEN_FOR_WORK_FAILED'
export const GET_ALL_ASSIGNMENTS = '@@openForWork/GET_ALL_ASSIGNMENTS'
export const GET_ALL_ASSIGNMENTS_SUCCESS =
  '@@openForWork/GET_ALL_ASSIGNMENTS_SUCCESS'
export const GET_ALL_ASSIGNMENTS_FAILED =
  '@@openForWork/GET_ALL_ASSIGNMENTS_FAILED'
export const UPDATE_VIEW_ASSIGNMENT = '@@openforwork/UPDATE_VIEW_ASSIGNMENT'
export const PIN_ASSIGNMENT = '@@openforwork/PIN_ASSIGNMENT'
export const PIN_ASSIGNMENT_SUCCESS = '@@openforwork/PIN_ASSIGNMENT_SUCCESS'
export const PIN_ASSIGNMENT_FAILED = '@@openforwork/PIN_ASSIGNMENT_FAILED'
export const SET_TOTAL_ASSIGNMENTS = '@@openforwork/SET_TOTAL_ASSIGNMENTS'
export const SET_TOTAL_APPLICATIONS = '@@openforwork/SET_TOTAL_APPLICATIONS'
export const SET_TOTAL_WORKSHIFTS = '@@openforwork/SET_TOTAL_WORKSHIFTS'
export const APPLY_ASSIGNMENT = '@@openforwork/APPLY_ASSIGNMENT'
export const CANCEL_APPLY_ASSIGNMENT = '@@openforwork/CANCEL_APPLY_ASSIGNMENT'
export const SEARCH_ASSIGNMENT = '@@openforwork/SEARCH_ASSIGNMENT'
export const SEARCH_ASSIGNMENT_SUCCESS =
  '@@openforwork/SEARCH_ASSIGNMENT_SUCCESS'
export const SEARCH_ASSIGNMENT_FAILED = '@@openforwork/SEARCH_ASSIGNMENT_FAILED'
export const SEND_APPLICATION = '@@openforwork/SEND_APPLICATION'
export const SEND_APPLICATION_SUCCESS = '@@openforwork/SEND_APPLICATION_SUCCESS'
export const SEND_APPLICATION_FAILED = '@@openforwork/SEND_APPLICATION_FAILED'
export const CLOSE_SUCCESS_SEND_APPLICATION =
  '@@openforwork/CLOSE_SUCCESS_SEND_APPLICATION'
export const SEE_MY_APPLICATION = '@@openforwork/SEE_MY_APPLICATION'
export const GET_ASSIGNMENT_OFFERED_TO_EMAIL =
  '@@openforwork/GET_ASSIGNMENT_OFFERED_TO_EMAIL'
export const GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS =
  '@@openforwork/GET_ASSIGNMENT_OFFERED_TO_EMAIL_SUCCESS'
export const GET_ASSIGNMENT_OFFERED_TO_EMAIL_FAILED =
  '@@openforwork/GET_ASSIGNMENT_OFFERED_TO_EMAIL_FAILED'
export const TRACK_APPLICATION = '@@openforwork/TRACK_APPLICATION'
export const TRACK_APPLICATION_SUCCESS =
  '@@openforwork/TRACK_APPLICATION_SUCCESS'
export const TRACK_APPLICATION_FAILED = '@@openforwork/TRACK_APPLICATION_FAILED'
export const WORKSHIFT_PAGE_CHANGE = '@@openforwork/WORKSHIFT_PAGE_CHANGE'
export const GET_WORKSHIFT_USER = '@@openforwork/GET_WORKSHIFT_USER'
export const GET_WORKSHIFT_USER_SUCCESS =
  '@@openforwork/GET_WORKSHIFT_USER_SUCCESS'
export const GET_WORKSHIFT_USER_FAILED =
  '@@openforwork/GET_WORKSHIFT_USER_FAILED'
export const GET_BILLABLE_HOUR_USER = '@@openforwork/GET_BILLABLE_HOUR_USER'
export const GET_BILLABLE_HOUR_USER_SUCCESS =
  '@@openforwork/GET_BILLABLE_HOUR_USER_SUCCESS'
export const GET_BILLABLE_HOUR_USER_FAILED =
  '@@openforwork/GET_BILLABLE_HOUR_USER_FAILED'
export const UPDATE_USER_WORKSHIFT = '@@openforwork/UPDATE_USER_WORKSHIFT'
export const UPDATE_USER_WORKSHIFT_SUCCESS =
  '@@openforwork/UPDATE_USER_WORKSHIFT_SUCCESS'
export const UPDATE_USER_WORKSHIFT_FAILED =
  '@@openforwork/UPDATE_USER_WORKSHIFT_FAILED'
export const REQUEST_EDIT_ACTUAL_HOUR = '@@openforwork/REQUEST_EDIT_ACTUAL_HOUR'
export const REQUEST_EDIT_ACTUAL_HOUR_SUCCESS =
  '@@openforwork/REQUEST_EDIT_ACTUAL_HOUR_SUCCESS'
export const REQUEST_EDIT_ACTUAL_HOUR_FAILED =
  '@@openforwork/REQUEST_EDIT_ACTUAL_HOUR_FAILED'
export const WORKSHIFT_BY_EMPLOYER = '@@openforwork/WORKSHIFT_BY_EMPLOYER'
export const GET_EMPLOYER_WORKSHIFT = '@@openforwork/GET_EMPLOYER_WORKSHIFT'
export const GET_EMPLOYER_WORKSHIFT_SUCCESS =
  '@@openforwork/GET_EMPLOYER_WORKSHIFT_SUCCESS'
export const GET_EMPLOYER_WORKSHIFT_FAILED =
  '@@openforwork/GET_EMPLOYER_WORKSHIFT_FAILED'
export const GET_JOURNAL = '@@openforwork/GET_JOURNAL'
export const GET_JOURNAL_SUCCESS = '@@openforwork/GET_JOURNAL_SUCCESS'
export const GET_JOURNAL_FAILED = '@@openforwork/GET_JOURNAL_FAILED'
export const ADD_JOURNAL_DETAIL = '@@openforwork/ADD_JOURNAL_DETAIL'
export const ADD_JOURNAL_DETAIL_SUCCESS =
  '@@openforwork/ADD_JOURNAL_DETAIL_SUCCESS'
export const ADD_JOURNAL_DETAIL_FAILED =
  '@@openforwork/ADD_JOURNAL_DETAIL_FAILED'
export const GET_JOURNAL_EDIT = '@@openforwork/GET_JOURNAL_EDIT'
export const GET_JOURNAL_EDIT_SUCCESS = '@@openforwork/GET_JOURNAL_EDIT_SUCCESS'
export const GET_JOURNAL_EDIT_FAILED = '@@openforwork/GET_JOURNAL_EDIT_FAILED'
export const CANCEL_JOURNAL_EDIT = '@@openforwork/CANCEL_JOURNAL_EDIT'
export const DELETE_JOURNAL = '@@openforwork/DELETE_JOURNAL'
export const DELETE_JOURNAL_SUCCESS = '@@openforwork/DELETE_JOURNAL_SUCCESS'
export const DELETE_JOURNAL_FAILED = '@@openforwork/DELETE_JOURNAL_FAILED'
export const WARN_DELETE_JOURNAL = '@@openforwork/WARN_DELETE_JOURNAL'
export const CLOSE_WARN_DELETE_JOURNAL =
  '@@openforwork/CLOSE_WARN_DELETE_JOURNAL'
export const CLOSE_USER_WORKSHIFT_SNACKBAR =
  '@@openforwork/CLOSE_USER_WORKSHIFT_SNACKBAR'
export const UPDATE_JOURNAL_DETAIL = '@@openforwork/UPDATE_JOURNAL_DETAIL'
export const UPDATE_JOURNAL_DETAIL_SUCCESS =
  '@@openforwork/UPDATE_JOURNAL_DETAIL_SUCCESS'
export const UPDATE_JOURNAL_DETAIL_FAILED =
  '@@openforwork/UPDATE_JOURNAL_DETAIL_FAILED'
export const PIN_WORKSHIFT = '@@openforwork/PIN_WORKSHIFT'
export const PIN_WORKSHIFT_SUCCESS = '@@openforwork/PIN_WORKSHIFT_SUCCESS'
export const PIN_WORKSHIFT_FAILED = '@@openforwork/PIN_WORKSHIFT_FAILED'

export const OPEN_SIGN_BOX = '@@application/OPEN_SIGN_BOX'
export const CANCEL_OPEN_SIGN_BOX = '@@application/CANCEL_OPEN_SIGN_BOX'
export const REJECT_ASSIGNMENT = '@@application/REJECT_ASSIGNMENT'
export const REJECT_ASSIGNMENT_SUCCESS =
  '@@application/REJECT_ASSIGNMENT_SUCCESS'
export const ASK_BEFORE_REJECT_ASSIGNMENT =
  '@@application/ASK_BEFORE_REJECT_ASSIGNMENT'
export const CANCEL_REJECT_ASSIGNMENT = '@@application/CANCEL_REJECT_ASSIGNMENT'
export const GET_APPLICATION_PROFILE = '@@application/GET_APPLICATION_PROFILE'
export const GET_APPLICATION_PROFILE_SUCCESS =
  '@@application/GET_APPLICATION_PROFILE_SUCCESS'
export const GET_APPLICATION_PROFILE_FAILED =
  '@@application/GET_APPLICATION_PROFILE_FAILED'
export const CLOSE_APPLICATION_PROFILE =
  '@@application/CLOSE_APPLICATION_PROFILE'
export const SIGN_AND_SEND_ASSIGNMENT = '@@application/SIGN_AND_SEND_ASSIGNMENT'
export const SIGN_AND_SEND_ASSIGNMENT_SUCCESS =
  '@@application/SIGN_AND_SEND_ASSIGNMENT_SUCCESS'
export const SIGN_AND_SEND_ASSIGNMENT_FAILED =
  '@@application/SIGN_AND_SEND_ASSIGNMENT_FAILED'
export const CLOSE_APPLICATION_SNACKBAR =
  '@@application/CLOSE_APPLICATION_SNACKBAR'
export const APPLICATION_LIST_PAGE_CHANGE =
  '@@application/APPLICATION_LIST_PAGE_CHANGE'
export const LOAD_SIGN_SEND = '@@application/LOAD_SIGN_SEND'
export const CLOSE_LOAD_SIGN_SEND = '@@application/CLOSE_LOAD_SIGN_SEND'
export const UPDATE_VIEW_APPLICATION = '@@openforwork/UPDATE_VIEW_APPLICATION'
export const UPDATE_VIEW_WORKSHIFT = '@@openforwork/UPDATE_VIEW_WORKSHIFT'
export const PIN_APPLICATION = '@@application/PIN_APPLICATION'
export const PIN_APPLICATION_SUCCESS = '@@application/PIN_APPLICATION_SUCCESS'
export const PIN_APPLICATION_FAILED = '@@application/PIN_APPLICATION_FAILED'

export const DUE_DATE_FEE = 10
export const PARTIAL_PAY_FEE = 10
export const INTEREST_PERCENT = 7
export const INTEREST_FEE = 0.07
export const SELECTED_CUSTOMER_TYPE = 'SELECTED_CUSTOMER_TYPE'
// KAS-335 construction/shipbuilding industry tax card

export const SHIPBUILDING_INDUSTRY_TAX_CARD = 'SHIPBUILDING_INDUSTRY_TAX_CARD'
export const SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS =
  'SHIPBUILDING_INDUSTRY_TAX_CARD_SUCCESS'
export const SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED =
  'SHIPBUILDING_INDUSTRY_TAX_CARD_FAILED'

export const GET_INDUSTRY_TAX_CARD = 'GET_INDUSTRY_TAX_CARD'
export const GET_INDUSTRY_TAX_CARD_SUCCESS = 'GET_INDUSTRY_TAX_CARD_SUCCESS'
export const GET_INDUSTRY_TAX_CARD_FAILED = 'GET_INDUSTRY_TAX_CARD_FAILED'

// export const GENERATE_INDUSTRY_TAX_PDF = 'GENERATE_INDUSTRY_TAX_PDF'
export const GENERATE_INDUSTRY_TAX_PDF_SUCCESS =
  'GENERATE_INDUSTRY_TAX_PDF_SUCCESS'
export const GENERATE_INDUSTRY_TAX_PDF_FAILED =
  'GENERATE_INDUSTRY_TAX_PDF_FAILED'

export const GO_TO_RIMINDER = 'GO_TO_RIMINDER'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
// KAS-339 SELECTED_CUSTOMER_TYPE action don't use any more, use WatchField instead

// File is under 5MB
export const FILE_MAX_SIZE = 5 * 1024 * 1024

export const MAX_LOGO_WIDTH = 800
export const MAX_LOGO_HEIGHT = 800
export const SET_ADDING_LOGO = '@@profile/SET_ADDING_LOGO'
export const SAVE_LOGO = '@@profile/SAVE_LOGO'
export const SAVE_LOGO_SUCCESS = '@@profile/SAVE_LOGO_SUCCESS'
export const SAVE_LOGO_FAILED = '@@profile/SAVE_LOGO_FAILED'
export const GET_LOGO = '@@profile/GET_LOGO'
export const GET_LOGO_SUCCESS = '@@profile/GET_LOGO_SUCCESS'
export const DELETE_LOGO = '@@profile/DELETE_LOGO'
export const DELETE_LOGO_SUCCESS = '@@profile/DELETE_LOGO_SUCCESS'
export const DELETE_LOGO_FAILED = '@@profile/DELETE_LOGO_FAILED'
export const INVALID_LOGO = '@@profile/INVALID_LOGO'
export const CLOSE_LOGO_SNACKBAR = '@@profile/CLOSE_LOGO_SNACKBAR'

export const CHANGE_ROWS_PER_PAGE = 'CHANGE_ROWS_PER_PAGE'
export const EXPAND_ADMIN_SALARY = '@@admin/EXPAND_ADMIN_SALARY'
export const EXPAND_ADMIN_SALARY_TRUE = '@@admin/EXPAND_ADMIN_SALARY_TRUE'
export const EXPAND_ADMIN_SALARY_FALSE = '@@admin/EXPAND_ADMIN_SALARY_FALSE'
export const UPDATE_ADMIN_SALARY = '@@admin/UPDATE_ADMIN_SALARY'
export const CLOSE_ADMIN_SALARY_FORMS = '@@admin/CLOSE_ADMIN_SALARY_FORMS'

export const CLOSE_ADMIN_SALARY_FORMS_SUCCESS =
  '@@admin/CLOSE_ADMIN_SALARY_FORMS_SUCCESS'
export const GET_REGISTERED_USERS_LIST = '@@invoice/GET_REGISTERED_USERS_LIST'
export const GET_REGISTERED_USERS_LIST_SUCCESS =
  '@@invoice/GET_REGISTERED_USERS_LIST_SUCCESS'
export const GET_REGISTERED_USERS_LIST_FAILED =
  '@@invoice/GET_REGISTERED_USERS_LIST_FAILED'
export const GET_INVOICE_USER_EMAIL = '@@invoice/GET_INVOICE_USER_EMAIL'

export const OPEN_COMPANY_NOTIFICATION_DIALOG =
  'OPEN_COMPANY_NOTIFICATION_DIALOG'
export const CLOSE_COMPANY_NOTIFICATION_DIALOG =
  'CLOSE_COMPANY_NOTIFICATION_DIALOG'

export const REMOVE_INVOICE_FEE_WITH_REASON =
  '@@admin/REMOVE_INVOICE_FEE_WITH_REASON'
export const CANCEL_REMOVE_INVOICE_FEE_DIALOG =
  '@@admin/CANCEL_REMOVE_INVOICE_FEE_DIALOG'

// KAS-634 Standard VAT 25,5% from 01.09.2024
// https://www.vero.fi/en/businesses-and-corporations/taxes-and-charges/vat/rates-of-vat/new-vat-rate-from-1-september-2024--instructions-for-vat-reporting/#:~:text=From%201%20September%2C%20the%20general,from%2024%25%20to%2025.5%25
export const STANDARD_VAT_CALCULATION_INDEX = 1.255

export const DOWNLOAD_CUSTOMERS_REPORT = 'DOWNLOAD_CUSTOMERS_REPORT'
export const SET_CUSTOMER_FORM_READONLY = 'SET_CUSTOMER_FORM_READONLY'

export const COPY_ALLOWANCE = 'COPY_ALLOWANCE'

export const UPDATE_USER_EMAIL = '@@profile/UPDATE_USER_EMAIL'
export const UPDATE_USER_EMAIL_SUCCESS = '@@profile/UPDATE_USER_EMAIL_SUCCESS'
export const UPDATE_USER_EMAIL_FAILED = '@@profile/UPDATE_USER_EMAIL_FAILED'
export const VERIFY_USER_PROFILE = '@@profile/VERIFY_USER_PROFILE'

export const SHOW_INVOICE_FORM_DIALOG = '@@profile/SHOW_INVOICE_FORM_DIALOG'
export const CLOSE_INVOICE_FORM_DIALOG = '@@profile/CLOSE_INVOICE_FORM_DIALOG'

export const RESET_INVOICES = '@@profile/RESET_INVOICES'
